import actionTypes from './actionTypes'

const onboardingGuideActions = {

	fetched: payload => ({
		type: actionTypes.ONBOARDING_GUIDE_DATA_FETCHED,
		payload,
	}),

	failed: serverError => ({
		type: actionTypes.ONBOARDING_GUIDE_DATA_FAILED,
		serverError,
	}),

	launchTourCard: () => ({
		type: actionTypes.ONBOARDING_GUIDE_LAUNCH_TOUR_CARD_SELECTED,
	}),

	launchTourCardSuccess: () => ({
		type: actionTypes.ONBOARDING_GUIDE_LAUNCH_TOUR_CARD_SUCCESS,
	}),

	enabled: payload => ({
		type: actionTypes.ONBOARDING_GUIDE_ENABLED,
		payload,
	}),

	dismissConfirm: () => ({
		type: actionTypes.ONBOARDING_GUIDE_DISMISS_CONFIRM,
	}),

	cancelDismiss: () => ({
		type: actionTypes.ONBOARDING_GUIDE_DISMISS_CANCELLED,
	}),

	confirmDismiss: () => ({
		type: actionTypes.ONBOARDING_GUIDE_DISMISS_CONFIRMED,
	}),

	explorelessons: () => ({
		type: actionTypes.ONBOARDING_GUIDE_EXPLORE_LESSONS_CARD_SELECTED,
	}),

	createLesson: () => ({
		type: actionTypes.ONBOARDING_GUIDE_LESSON_BUILDER_CARD_SELECTED,
	}),

	createLessonSuccess: () => ({
		type: actionTypes.ONBOARDING_GUIDE_LESSON_BUILDER_CARD_SUCCESS,
	}),

	sessionPreview: presentation_uid => ({
		type: actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SELECTED,
		presentation_uid,
	}),

	sessionPreviewSuccess: (payload, presentation_uid) => ({
		type: actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SUCCESS,
		payload,
		presentation_uid,
	}),

	sessionPreviewFailed: serverError => ({
		type: actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_FAILED,
		serverError,
	}),
}

export default onboardingGuideActions
